"use client";

import dynamic from "next/dynamic";

const PengumumanDetail = dynamic(() => import("@/app/Components/Pages/PengumumanDetail"), {
    ssr: false
});

export default function PengumumanDetailWrapper({ documentId }) {
  return <PengumumanDetail documentId={documentId} />;
}
